import api from "@/lib/api";

// Show-then-refresh GETs: hand back the last saved response right away (per sign-in, this tab only),
// then fetch fresh data quietly and save it for next time. Concurrent calls for the same URL share one request.
const PREFIX = "rpg_swr:";
const inflight = new Map();
const keyFor = (url) => `${PREFIX}${(localStorage.getItem("rallypointgo_token") || "").slice(-24)}:${url}`;

export function readCached(url) {
  try { const hit = sessionStorage.getItem(keyFor(url)); return hit ? JSON.parse(hit) : null; } catch { return null; }
}

export function fetchFresh(url) {
  const key = keyFor(url);
  if (inflight.has(key)) return inflight.get(key);
  const p = api.get(url).then(({ data }) => {
    // Skip saving if the user signed out (or switched accounts) while this request was in flight.
    if (keyFor(url) === key) try { sessionStorage.setItem(key, JSON.stringify(data)); } catch { /* storage full: skip caching */ }
    return data;
  }).finally(() => inflight.delete(key));
  inflight.set(key, p);
  return p;
}

// useCache=false after a save, so the screen never flashes back to the older copy.
export function cachedGet(url, onData, useCache = true) {
  if (useCache) { const hit = readCached(url); if (hit) onData(hit); }
  return fetchFresh(url).then((data) => { onData(data); return data; });
}

export const prefetch = (urls) => urls.forEach((u) => { if (!readCached(u)) fetchFresh(u).catch(() => {}); });

export function clearCachedGets() {
  try { Object.keys(sessionStorage).filter((k) => k.startsWith(PREFIX)).forEach((k) => sessionStorage.removeItem(k)); } catch { /* ignore */ }
}
